import { useQuery } from "@tanstack/react-query";
import {
  getLatestRecurring,
  getRecurringChanges,
  listRecurringRuns,
  getRecurringAlert,
} from "../api/recurring.js";
import type {
  RecurringRunSummary,
  RecurringChangeSummary,
} from "../api/product-types.js";
import type { RecurringAlertSummary } from "@accessimonitor/contracts";

export function useLatestRecurring(websiteId: string | undefined) {
  return useQuery<RecurringRunSummary | null>({
    queryKey: ["recurring", websiteId],
    queryFn: () => {
      if (!websiteId) throw new Error("websiteId is required");
      return getLatestRecurring(websiteId);
    },
    enabled: websiteId != null,
  });
}

export function useRecurringChanges(
  websiteId: string | undefined,
  runId: string | undefined,
) {
  return useQuery<RecurringChangeSummary | null>({
    queryKey: ["recurring-changes", websiteId, runId],
    queryFn: () => {
      if (!websiteId) throw new Error("websiteId is required");
      if (!runId) throw new Error("runId is required");
      return getRecurringChanges(websiteId, runId);
    },
    enabled: websiteId != null && runId != null,
  });
}

export function useRecurringList(websiteId: string | undefined) {
  return useQuery<RecurringRunSummary[]>({
    queryKey: ["recurring-list", websiteId],
    queryFn: () => {
      if (!websiteId) throw new Error("websiteId is required");
      return listRecurringRuns(websiteId);
    },
    enabled: websiteId != null,
  });
}

export function useRecurringAlert(
  websiteId: string | undefined,
  runId: string | undefined,
) {
  return useQuery<RecurringAlertSummary | null>({
    queryKey: ["recurring-alert", websiteId, runId],
    queryFn: () => {
      if (!websiteId) throw new Error("websiteId is required");
      if (!runId) throw new Error("runId is required");
      return getRecurringAlert(websiteId, runId);
    },
    enabled: websiteId != null && runId != null,
  });
}
